import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { config } from '@abyss/ui/tools/config';
import { Modal } from '@abyss/web/ui/Modal';
import { Button } from '@abyss/web/ui/Button';
import { styled } from '@abyss/web/tools/styled';
import { storage } from '@abyss/ui/tools/storage';
import { getFeature } from 'src/tools/features';
import { Countdown } from './Countdown';
import {
  TIME_TO_SIGNOUT_AFTER_IDLE_IN_MINUTES,
  RESET_TIME,
  HAS_SIGNED_OUT,
} from '../constants';

const ButtonWrapper = styled('div', {
  margin: '0px 8px',
});
const ModalText = styled('div', {
  lineHeight: '32px',
});

export const IdleModal = ({ isOpen, closeModal }) => {
  const [originalExpiredTime, setOriginalExpiredTime] = useState();
  const handleSignout = () => {
    storage.local.set(HAS_SIGNED_OUT, true);
    window.location.href = `${
      getFeature('OHID_SESSION_REWORK')
        ? `${config('IDENTITY_API_URL')}/logout/v2`
        : `${config('IDENTITY_API_URL')}/logout`
    }`;
  };

  useEffect(() => {
    setOriginalExpiredTime(storage.local.get(RESET_TIME));
  }, [isOpen]);

  const handleTick = timeMS => {
    if (originalExpiredTime !== storage.local.get(RESET_TIME)) {
      closeModal();
    }

    if (storage.local.get(HAS_SIGNED_OUT)) handleSignout();
  };

  return (
    <Modal
      title="Session Timeout Warning"
      size="md"
      isOpen={isOpen}
      onClose={closeModal}
      closeOnClickOutside={false}
      hideClose
      css={{
        'abyss-modal-body': {
          borderStyle: 'solid',
          borderWidth: '2px 0px 0px 0px',
          borderColor: 'gray',
        },
      }}
      footer={
        <Modal.Section
          css={{
            'abyss-modal-section-root': {
              display: 'flex',
              justifyContent: 'center',
            },
          }}
        >
          <ButtonWrapper>
            <Button variant="outline" onClick={handleSignout}>
              Sign Out
            </Button>
          </ButtonWrapper>
          <ButtonWrapper>
            <Button onClick={closeModal}>Continue Working</Button>
          </ButtonWrapper>
        </Modal.Section>
      }
    >
      <Modal.Section
        css={{
          'abyss-modal-section-root': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          },
        }}
      >
        <ModalText>
          You will be signed out in a few minutes due to inactivity.
        </ModalText>
        <ModalText>All unsaved data on this page will be lost.</ModalText>
        <ModalText>
          Time remaining:{' '}
          <Countdown
            countdownMS={TIME_TO_SIGNOUT_AFTER_IDLE_IN_MINUTES * 60 * 1000}
            onTick={handleTick}
            onComplete={handleSignout}
          />
        </ModalText>
      </Modal.Section>
    </Modal>
  );
};

IdleModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};
